import { render, staticRenderFns } from "./dialogTransferPermission.vue?vue&type=template&id=70cc3d82&scoped=true"
import script from "./dialogTransferPermission.vue?vue&type=script&lang=js"
export * from "./dialogTransferPermission.vue?vue&type=script&lang=js"
import style0 from "./dialogTransferPermission.vue?vue&type=style&index=0&id=70cc3d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc3d82",
  null
  
)

export default component.exports